module.exports = __webpack_public_path__ + "static/media/react-logo.b779e4fd.svg";